import Layton151 from '../../../Media/BSD/Navapark/Layton 15.webp'
import Layton152 from '../../../Media/BSD/Navapark/Layton 15.webp'





const Layton15images =[
Layton151,Layton152
]

export default Layton15images;